import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { NewUserMapper } from "@app/core/user/data/network/new-user.mapper";
import { NewUserData } from "@app/core/user/domain/new-user";
import { LoginResponse } from "@app/core/user/domain/login.reponse";
import { LoginMapper } from "@app/core/user/data/network/login.mapper";

@Injectable({
  providedIn: "root",
})
export class RegisterWS {
  constructor(private handler: BaseHandler) {}

  execute(newUserData: NewUserData): Observable<LoginResponse> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.REGISTER_ENDPOINT())
      .setMethod(HttpMethod.post)
      .setBody(NewUserMapper.serialize(newUserData))
      .build();
    return this.handler
      .execute(parameters)
      .pipe(map((response) => LoginMapper.deserialize(response)));
  }
}
